<template>
  <div>
    <div class="container-fluid m-0 p-0 bg-white" >
      <bildSchwenkMitText />
      <firmenBeschreibung/>
      <bildMitKacheln/>
    </div>
    <stickybarTelMail />
  </div>
  <stickyPfeil/>
</template>

<script>
//import carouselHeader from "../components/carouselHeader.vue";
import stickybarTelMail from "../components/stickybarTelMail.vue";
import stickyPfeil from "../components/stickyPfeil.vue";

import bildSchwenkMitText from "../components/bildSchwenkMitText.vue";
import firmenBeschreibung from "../components/FirmenBeschreibung.vue";
import bildMitKacheln from "../components/bildMitKacheln.vue";

export default {
  name: "MainPage",

  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      newSite: null,
    };
  },
  components: {
    stickybarTelMail,
    bildSchwenkMitText,
    stickyPfeil,
    //  carouselHeader,
    firmenBeschreibung,
    bildMitKacheln,
  },
  methods: {},
  computed: {},
  mounted() {
    window.onresize = () => {
      this.windowHeight = window.innerHeight;
    };
  },
};
</script>

<style scoped></style>
